// extracted by mini-css-extract-plugin
export default {"ProfileCard":"ProfileCard_ProfileCard__3OSxB","Text":"ProfileCard_Text__r+CMG","User":"ProfileCard_User__jbXwV","SP":"ProfileCard_SP__7-2TZ"};